import { useState } from 'react';

/**
 * Drop-in replacement for <img> inside card/grid layouts.
 * Shows a shimmer skeleton while loading, then fades in.
 */
export default function LazyImage({
  src, alt = '', className, style,
  wrapperStyle, wrapperClassName,
  loading = 'lazy',
  objectFit = 'cover',
  ...rest
}) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className={wrapperClassName}
      style={{
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: '#e2e8f0',
        ...wrapperStyle,
      }}
    >
      {!loaded && <div className="lazy-shimmer" style={{ position: 'absolute', inset: 0 }} />}
      <img
        src={src}
        alt={alt}
        loading={loading}
        className={className}
        onLoad={() => setLoaded(true)}
        style={{
          width: '100%',
          height: '100%',
          objectFit,
          display: 'block',
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.45s ease',
          ...style,
        }}
        {...rest}
      />
    </div>
  );
}
